import { render, staticRenderFns } from "./FenceManagement.vue?vue&type=template&id=838532e8&scoped=true&"
import script from "./FenceManagement.vue?vue&type=script&lang=js&"
export * from "./FenceManagement.vue?vue&type=script&lang=js&"
import style0 from "./FenceManagement.vue?vue&type=style&index=0&id=838532e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "838532e8",
  null
  
)

export default component.exports